var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Email',{attrs:{"emails_vet":_vm.vets,"emails_owners":_vm.owners,"auth_token":_vm.auth_token,"admin":_vm.user.role.slug == 'admin'}})}
var staticRenderFns = []

export { render, staticRenderFns }